import { useEffect, useState } from 'react'
import { getDatabase, ref, onValue } from 'firebase/database'

const useGetTokens = () => {
  const [tokens, setTokens] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const db = getDatabase()
    const tokensRef = ref(db, 'Tokens')
    const unsubscribe = onValue(tokensRef, (snapshot) => {
      const data = snapshot.val()
      if (!data) {
        setTokens([])
      } else {
        const list = Object.entries(data).map(([id, val]) => ({
          id,
          name: val.name,
          token: val.token
        }))
        setTokens(list.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1))
      }
      setLoading(false)
    })
    return () => unsubscribe()
  }, [])

  return { tokens, loading }
}

export default useGetTokens
